import { deepFreeze } from "./../../utils/deepFreeze";

export function stateFreezer(reducer: any) {
  return function freezer(state: any, action: any) {
    // freeze the state and run the original reducer
    // deepFreeze(state);
    const newState = reducer(state, action);

    // freeze and return the result state
    // deepFreeze(newState);
    return newState;
  };
}
